// src/lib/mixpanel.js
import mixpanel from 'mixpanel-browser';

let initialized = false;

export function initMixpanel(token) {
  if (!token || initialized) return;
  mixpanel.init(token, {
    debug: true,
    track_pageview: true,
    persistence: 'localStorage',
    record_sessions_percent: 100, //records 100% of all sessions
    record_heatmap_data: true,
  });
  initialized = true;
}

// Basic wrappers (guards ensure no-ops if not initialized)
export function track(eventName, properties = {}) {
  if (!initialized) return;
  mixpanel.track(eventName, properties);
}

export function identify(userId) {
  if (!initialized) return;
  mixpanel.identify(userId);
}

export function setUserProperties(properties = {}) {
  if (!initialized) return;
  // sets properties for current user profile
  mixpanel.people && mixpanel.people.set(properties);
}

export function registerSuperProperties(props = {}) {
  if (!initialized) return;
  mixpanel.register(props);
}

export function reset() {
  if (!initialized) return;
  mixpanel.reset(); // clears distinct_id and device id
}

export function optOut() {
  // Prevents sending future events for this user (persisted)
  if (!initialized) return;
  mixpanel.opt_out_tracking && mixpanel.opt_out_tracking();
}

export function optIn() {
  if (!initialized) return;
  mixpanel.opt_in_tracking && mixpanel.opt_in_tracking();
}

export function getDistinctId() {
  if (!initialized) return null;
  return mixpanel.get_distinct_id();
}
